<template>
  <div>
    <b-modal
      id="modal-sorting-bucket-manage"
      ref="modal"
      v-model="open"
      hide-footer
      no-close-on-backdrop
      size="lg"
      :title="modalTitle"
    >
      <b-overlay
        id="overlay-background"
        :show="loading"
        blur="10px"
        opacity="0.30"
        rounded="sm"
        variant="light"
      >
        <ValidationObserver
          ref="sortingBucketManageForm"
          v-slot="{ handleSubmit }"
          slim
        >
          <b-form
            class="my-8"
            @submit.prevent="handleSubmit(handleFormSubmit)"
          >
            <b-row>
              <b-col
                cols="12"
              >
                <b-form-group
                  label="Branch"
                  label-cols-md="4"
                  label-for="h-branch"
                >
                  <v-select
                    v-model="form.model_id"
                    :options="branchOptions"
                    :reduce="option => option.id"
                    label="name"
                    placeholder="Select Branch"
                    :disabled="modalPurpose === 'edit'"
                  >
                    <template v-slot:option="option">
                      {{ option.name }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
              >
                <b-form-group
                  label="Bucket"
                  label-cols-md="4"
                  label-for="h-bucket"
                >
                  <v-select
                    v-model="form.bucket_id"
                    :options="bucketOptions"
                    :reduce="option => option.id"
                    label="name"
                    placeholder="Select Bucket"
                  >
                    <template v-slot:option="option">
                      {{ option.name }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <!-- submit and reset -->
              <b-col
                offset-md="4"
              >
                <div>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    class="mr-1 custom-button-color"
                    type="submit"
                  >
                    Submit
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    variant="outline-secondary"
                    @click="clearOnClick"
                  >
                    Clear
                  </b-button>
                </div>
              </b-col>
            </b-row>

          </b-form>
        </ValidationObserver>
      </b-overlay>
    </b-modal>

  </div>
</template>

<script>
import {
  BButton,
  BModal,
  BCol,
  BFormGroup,
  BForm,
  BRow,
  BOverlay,
  VBModal,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const sortingRepository = RepositoryFactory.get('sorting')

function initialState() {
  return {
    open: false,
    id: null,
    modalPurpose: 'add',
    loading: false,
    form: {
      id: null,
      model_id: null,
      bucket_id: null,
    },
    branchOptions: [],
    bucketOptions: [],
  }
}

export default {
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BButton,
    BModal,
    BCol,
    BFormGroup,
    BForm,
    BRow,
    BOverlay,
    vSelect,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return initialState()
  },
  computed: {
    modalTitle() {
      // eslint-disable-next-line no-nested-ternary
      return this.modalPurpose === 'add' ? 'ADD BUCKET' : 'EDIT BUCKET'
    },
  },
  methods: {
    async openModal(id, purpose) {
      await Object.assign(this.$data, initialState())
      this.loading = true
      this.open = true
      this.modalPurpose = purpose
      this.id = id
      await this.getBucketList()
      if (this.modalPurpose === 'edit') {
        await this.fetchAssignedBranches()
        await this.fetchSortingBucketDetails(this.id)
      } else {
        await this.fetchUnassignedBranches()
      }
      this.loading = false
    },
    async getBucketList() {
      try {
        this.bucketOptions = (await sortingRepository.getLastBuckets()).data.data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchUnassignedBranches() {
      try {
        const { data } = (await sortingRepository.getUnassignedBranches()).data
        this.branchOptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchAssignedBranches() {
      try {
        const { data } = (await sortingRepository.getAssignedBranches()).data
        this.branchOptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchSortingBucketDetails(id) {
      try {
        const { data } = (await sortingRepository.getSortingBucketDetails(id)).data
        this.form.id = data.id
        this.form.model_id = data.model_id
        this.form.bucket_id = data.parent.from_node_id
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async handleFormSubmit() {
      try {
        this.loading = true
        const data = {
          model_id: this.form.model_id,
          bucket_id: this.form.bucket_id,
        }
        let res
        if (this.modalPurpose === 'add') {
          res = await sortingRepository.createSortingBucket(data)
        } else {
          res = await sortingRepository.updateSortingBucket(this.form.id, data)
        }
        if (res.status === 200 || res.status === 201) {
          this.clearOnClick()
          this.open = false
          this.$parent.onClickRefresh()
          this.showSuccessMessage(`Bucket ${this.modalPurpose === 'add' ? 'Added' : 'Updated'} Successfully`)
        } else {
          this.showErrorMessage(`Cannot ${this.modalPurpose === 'add' ? 'Add' : 'Update'} Bucket`)
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    clearOnClick() {
      this.form = {}
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/required.scss';

</style>
